import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpParams } from '@angular/common/http';

/**
 * Sets the Content-Type HTTP header on non-GET requests that do not explicitly have a Content-Type already specified.
 *
 * Exempt: the body types Angular classifies correctly itself. Angular's `detectContentTypeHeader()` is only
 * consulted when the request carries no Content-Type, so setting one here pre-empts it -- which is right for a
 * body it would otherwise send as `text/plain`, and wrong for `FormData` (only the browser knows the multipart
 * boundary) and for `HttpParams` (`serializeBody()` writes `a=b&c=d` regardless, so a JSON label ships a form
 * body the server will not parse into request parameters -- CLOUD-286526). Exempting the type rather than
 * setting the header at each call site is deliberate: every future form-encoded request in this app hits the
 * same wall, and a call-site fix leaves the trap armed.
 */
@Injectable()
export class HttpContentTypeInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Note: If Content-Type is not specified, Angular ends up using "text/plain"

        if (
            request.method !== 'GET' &&
            request.body != null &&
            !request.headers?.get('Content-Type') &&
            !(request.body instanceof FormData) &&
            !(request.body instanceof HttpParams)
        ) {
            request = request.clone({
                setHeaders: {
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            });
        }

        return next.handle(request);
    }
}
